window.onload = function () {
  var section_id = "";
  var dialog = "";
  var modal_video_type = "";
  var modal_video_url = "";
  var modalShowButton = document.querySelectorAll(".show__play-media");
  var modalCloseButton = document.querySelectorAll(".close__play-media");

  // youtube poster
  var mediaPlayButton = document.querySelectorAll(".media-play-button");
  var mediaPoster = document.querySelectorAll(".media-poster");

  // Add dialog show button click event listener to each button
  modalShowButton.forEach((button) => {
    button.addEventListener("click", (event) => {
      section_id = event.target.getAttribute("data-id");
      modal_video_type = event.target.getAttribute("modal-video-type");
      modal_video_url = event.target.getAttribute("modal-video-url");
      dialog = document.getElementById("mediaPlayModal-" + section_id);
      dialog.showModal(); // Show the dialog
    });
  });

  // Add dialog close event listener to each button
  modalCloseButton.forEach((button) => {
    button.addEventListener("click", () => {
      if (modal_video_type == "youtube") {
        var youtube = document.getElementById(
          "modalYoutubeVideo-" + section_id
        );
        youtube.setAttribute("src", modal_video_url);
        youtube.currentTime = 0;
      }

      if (modal_video_type == "cdn") {
        var cdn = document.getElementById("modalCDNVideo-" + section_id);
        cdn.pause(); // Pause the video if it's playing
        cdn.currentTime = 0; // Reset the video to the beginning
      }

      if (modal_video_type == "vimeo") {
        var vimeo = document.getElementById("modalVimeo-" + section_id);
        vimeo.setAttribute("src", modal_video_url);
      }
      dialog.close(); // Show the dialog
    });
  });

  // Media poster events.
  mediaPlayButton.forEach((button) => {
    button.addEventListener("click", () => {
      const el = button.closest(".media-poster");
      var type = el.getAttribute("media-type");

      if (type == "vimeo") {
        var iframe = el.nextElementSibling;
        var player = new Vimeo.Player(iframe);
        player.play();
      }

      if (type == "youtube") {
        var youtubeIframe = el.nextElementSibling;
        const currentSrc = youtubeIframe.src;
        // Check if autoplay is already enabled
        if (!currentSrc.includes("autoplay=1")) {
          // Add autoplay parameter to the iframe src
          youtubeIframe.src =
            currentSrc + (currentSrc.includes("?") ? "&" : "?") + "autoplay=1";
        }
      }

      // Find a specific parent by selector
      el.style.display = "none";
    });
  });

  mediaPoster.forEach((el) => {
    el.addEventListener("click", () => {
      var type = el.getAttribute("media-type");
      if (type == "vimeo") {
        var iframe = el.nextElementSibling;
        var player = new Vimeo.Player(iframe);
        player.play();
      }

      if (type == "youtube") {
        var youtubeIframe = el.nextElementSibling;
        const currentSrc = youtubeIframe.src;
        // Check if autoplay is already enabled
        if (!currentSrc.includes("autoplay=1")) {
          // Add autoplay parameter to the iframe src
          youtubeIframe.src =
            currentSrc + (currentSrc.includes("?") ? "&" : "?") + "autoplay=1";
        }
      }

      el.style.display = "none";
    });
  });
};